import { jsx as _jsx } from "react/jsx-runtime";
import { ShortUrl } from "@air/api";
import { ShortUrlObjectType } from "@air/api/types";
import { BoardCollectionWrapper } from "~/components/BoardCollection/BoardCollectionWrapper";
import { ContentCollectionWrapper } from "~/components/ContentCollection/ContentCollectionWrapper";
import { ContentCollectionLayout } from "~/components/Layouts/ContentCollectionLayout";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { getPageUrl } from "~/utils/Url";
export var __N_SSG = true;
export default function BoardCollection(param) {
    let { seo, data, shortId, requireAccount } = param;
    const { contentCollection } = useTemporaryFeatureFlags();
    return /*#__PURE__*/ _jsx(ContentCollectionLayout, {
        data: data,
        seo: seo,
        shortId: shortId,
        children: contentCollection ? /*#__PURE__*/ _jsx(ContentCollectionWrapper, {
            requireAccount: requireAccount
        }) : /*#__PURE__*/ _jsx(BoardCollectionWrapper, {
            requireAccount: requireAccount
        })
    });
}
export async function fetchCollectionFormHeadData(shortId) {
    const getByShortIdResponse = await ShortUrl.getByShortId(shortId);
    if (getByShortIdResponse.type !== ShortUrlObjectType.form) {
        throw new Error("Failed to fetch a form from ShortUrl.getByShortId");
    }
    // TODO: Sort this out. What is the point of this URL
    const url = "https://app.air.inc/d/".concat(shortId);
    const title = "".concat(getByShortIdResponse.data.title, " / ").concat(getByShortIdResponse.data.workspace.name);
    var _getByShortIdResponse_data_description;
    const seo = {
        nofollow: true,
        noindex: true,
        title: "".concat(getByShortIdResponse.data.title, " / ").concat(getByShortIdResponse.data.workspace.name),
        description: (_getByShortIdResponse_data_description = getByShortIdResponse.data.description) !== null && _getByShortIdResponse_data_description !== void 0 ? _getByShortIdResponse_data_description : "",
        canonical: url,
        openGraph: {
            url,
            title: "".concat(title, " / Air"),
            description: "Submit content to ".concat(getByShortIdResponse.data.workspace.name, " quickly and securely on Air")
        }
    };
    const images = [
        {
            url: "".concat(getPageUrl(), "/assets/images/content-collection-sharecard.png"),
            alt: ""
        }
    ];
    if (images) {
        seo.openGraph = {
            ...seo.openGraph,
            images
        };
    }
    return {
        seo,
        data: getByShortIdResponse.data,
        requireAccount: getByShortIdResponse.requireAccount
    };
}
